export enum OnPremOrderStatus {
    Ordered = 1,
    PartialAssetAssigned = 2,
    AssetAssigned = 3,
    Recalled = 4,
    Encoded = 5,
    ReadyToSend = 6,
    SentToOem = 7,
    OnHold = 8,
    Cancelled = 9,
    Rejected = 10
}

export const mapToOnPremOrderStatus = (status: number): OnPremOrderStatus => {
    if (status in OnPremOrderStatus) {
        return status;
    }

    throw new Error("Incorrect OnPremOrder Status.");
};
